import { forwardRef } from 'react'

import { BaseInput } from './BaseInput'
import { BaseInputProps } from './props'

interface TextInputProps extends Omit<BaseInputProps, 'value' | 'onChange'> {
  value?: string | unknown | any
  onChange?: (v: string | any, e?: string) => void
}

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>((props: TextInputProps, ref) => (
  <BaseInput {...props} type="text" ref={ref} />
))
